import $ from '../core/Dom';
import Viewport from '../core/Viewport';
import Dispatch from '../core/Dispatch';
import * as eventKeys from '../lib/events';

export default (el, props) => {
    const $el = $(el);
    const $icon = $el.find('.icon');
    const $a = $el.find('svg.-svg-a');
    const $dotsSvg = $el.find('svg.-svg-dots');
    const $dots = $el.find('svg.-svg-dots circle');
    
    const animateEnter = () => {
        TweenLite.killTweensOf($a.get(0));
        TweenLite.to($a.get(0), 0.2, { x: $icon.width(), ease: Sine.easeIn });
        
        $dots.each((el, i) => {
            TweenLite.killTweensOf(el);
            TweenLite.to(el, 0.1, { delay: 0.1 + (0.05*i), opacity: 1 });
        });
    };
    
    const animateLeave = () => {
        TweenLite.killTweensOf($a.get(0));
        TweenLite.set($a.get(0), { x: -$icon.width() });

        $dots.each((el, i) => {
            TweenLite.killTweensOf(el);
            TweenLite.to(el, 0.1, { delay: 0.05*i, opacity: 0 });
        });

        TweenLite.to($a.get(0), 0.4, { delay: 0.2, x: 0, ease: Quart.easeOut });
    };
    
    const onResize = () => {
        
    };
    
    const init = () => {
        $dotsSvg.css({ display: 'block' });
        
        $dots.each((el, i) => {
            TweenLite.set(el, { opacity: 0 });
        });
        
        $el.on('mouseenter', () => {
            animateEnter();
        });
        
        $el.on('mouseleave', () => {
            animateLeave();
        });
        
        Viewport.on('resize', onResize);
    };
    
    const destroy = () => {

        Viewport.off('resize', onResize);
    };

    return {
        init,
        destroy
    };
};
